import { GetCalendarListRequest } from '@leid/api-orders'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { startOfMonth } from 'date-fns'
import i18n from 'i18next'

import apiClient from 'helpers/clients/apiClient'
import { RootState } from 'store/rootReducer'

import { displaySnackbar } from '../snackbar/snackbarSlice'

import { ProductAvailabilitiesListThunkReturnType } from './interfaces'

export const fetchProductAvailabilitiesList = createAsyncThunk<
  ProductAvailabilitiesListThunkReturnType,
  { itemId: number; orderItemId?: number },
  { state: RootState }
>('fetchProductAvailabilitiesList', async ({ itemId, orderItemId }, { dispatch, rejectWithValue }) => {
  try {
    const request: GetCalendarListRequest = {
      orderItemId: orderItemId,
      startDate: startOfMonth(new Date()),
    }

    const response = await apiClient.getProductCalendarList(itemId, request)
    if (!response.success || !response.data) {
      throw new Error('Error on fetching product availability info')
    }

    const calendar = response.data
    return { calendar }
  } catch (err) {
    console.log('Error on fetchProductAvailabilitiesList', err)
    dispatch(displaySnackbar({ message: i18n.t('error'), isError: true }))
    return rejectWithValue(err)
  }
})
